const a = {
  mainnet: "https://starknet-mainnet.public.blastapi.io",
  testnet: "https://starknet-testnet.public.blastapi.io"
}, e = {
  mainnet: "https://rpc.starknet.lava.build",
  testnet: "https://rpc.starknet-testnet.lava.build"
}, t = [a, e];
function s() {
  const n = Math.floor(Math.random() * t.length);
  return t[n];
}
export {
  s as g
};
